import type { MaybeRefOrGetter } from 'vue';
import type { GlobalSingleRelationFieldId } from '#layers/data-model/types/schema/ids';
import { computed, toValue } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/workspace/public';

export function useSingleRelationField(fieldId: MaybeRefOrGetter<GlobalSingleRelationFieldId | null | undefined>) {
	const { findSingleRelationFieldById } = useWorkspaceSchemaStore();
	return computed(() => {
		const fieldIdValue = toValue(fieldId);
		return fieldIdValue ? findSingleRelationFieldById(fieldIdValue) : undefined;
	});
}
